module.exports = __webpack_public_path__ + "static/media/logo.609a96a5.svg";